// Generated by CoffeeScript 1.11.1
var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

define('sp/ui/questions/question_forms/essay',['require','../question_form'],function(require) {
  var Essay, QuestionForm;
  QuestionForm = require('../question_form');
  return Essay = (function(superClass) {
    extend(Essay, superClass);

    function Essay() {
      this.textareaKeyupHandler = bind(this.textareaKeyupHandler, this);
      this.textareaKeypressHandler = bind(this.textareaKeypressHandler, this);
      return Essay.__super__.constructor.apply(this, arguments);
    }

    Essay.prototype.tagName = "div";

    Essay.prototype.$textarea = null;

    Essay.prototype.initialize = function(options) {
      return Essay.__super__.initialize.call(this, options);
    };

    Essay.prototype.render = function() {
      var $info;
      Essay.__super__.render.call(this);
      this.$textarea = $("<textarea>").appendTo(this.el).attr({
        name: this.model.get("_id"),
        id: this.model.get("_id"),
        maxlength: this.model.get('properties').max ? this.model.get('properties').max : void 0
      }).change(this.textareaKeyupHandler).keyup(this.textareaKeyupHandler).keypress(this.textareaKeypressHandler);
      $info = $("<ul>").addClass("essay-info");
      this.$minText = $("<li title=\"You must have at least " + (this.model.get('properties').min) + " characters\">").addClass("minimum").appendTo($info);
      this.$maxText = $("<li title=\"You can have no more than " + (this.model.get('properties').max) + " characters\">").addClass("maximum").appendTo($info);
      this.setMaxText(this.model.get('properties').max);
      this.setMinText(this.model.get('properties').min);
      this.$el.append($info);
      return this.el;
    };

    Essay.prototype.setValues = function(vals) {
      if (vals == null) {
        vals = this.values;
      }
      if (_.isArray(vals) || vals.length && (_.isString(vals[0]) || _.isNumber(vals[0]))) {
        return this.$textarea.val(vals[0]).trigger('keyup');
      }
    };

    Essay.prototype.setMaxText = function(max) {
      var labelText;
      if (max != null) {
        labelText = this.definitions.essayMax || "Characters Remaining";
        if (this.model.get('properties').max && this.model.get('properties').max > 0) {
          return this.$maxText.html(labelText + ": <span>" + max + "</span>");
        }
      }
    };

    Essay.prototype.setMinText = function(min) {
      var labelText;
      if (min != null) {
        labelText = this.definitions.essayMin || "Characters Needed";
        if (this.model.get('properties').min && this.model.get('properties').min > 0) {
          return this.$minText.html(labelText + ": <span>" + min + "</span>");
        }
      }
    };

    Essay.prototype.textareaKeypressHandler = function(e) {
      var totalCharacters;
      totalCharacters = e.target.value.length;
      if ((this.model.get('properties').max != null) && totalCharacters > this.model.get('properties').max) {
        return e.stopPropagation();
      }
    };

    Essay.prototype.textareaKeyupHandler = function(e) {
      var $target, charsNeeded, charsRemaining, totalCharacters, value;
      $target = $(e.target);
      value = $target.val();
      if (value && value.length) {
        value = value.trim();
      }
      totalCharacters = value.length;
      charsNeeded = this.model.get('properties').min - totalCharacters;
      charsRemaining = this.model.get('properties').max - totalCharacters;
      this.setMinText(charsNeeded <= 0 ? 0 : charsNeeded);
      this.setMaxText(charsRemaining <= 0 ? 0 : charsRemaining);
      if (value && value.length) {
        this.values = [value];
      } else {
        this.values = [];
      }
      return this.trigger(QuestionForm.UPDATE_EVENT, this);
    };

    return Essay;

  })(QuestionForm);
});

